// extracted by mini-css-extract-plugin
module.exports = {"templateContainer":"template2_templateContainer__S4OSD","shimmer":"template2_shimmer__nZljk"};